import { BaseModalContext } from '@alfalab/core-components-base-modal';

export const ModalContext = BaseModalContext;
